
<div style="display: flex;
overflow-y: auto;
text-align: center;
flex-direction: column;
flex-wrap: nowrap;
justify-content: center;
align-content: center;
align-items: center;">
  <div style="position: fixed;
  top: 11%;
  background: #424242;
  width: 280px;
  height: 140px;
  z-index: 90000;">
    <h3>Previous Jobs</h3>
    <p>Select a job below to overwrite the current form with its data. </p>
  </div>
	<div class = "three-row" style="flex-flow: wrap;
  margin-top: 140px;">
	    <div *ngFor="let job of jobs" style="border-width: 1px; border-color: whitesmoke; padding-bottom: 20px;border-width: 1px; width: 100%;">
	    	<h5>{{job.customer_jobtype}}</h5>
	    	<h5>{{job.schedule_date.substring(0,10)}}</h5>
	    	<button mat-raised-button color="green"  (click)="loadData(job.form_id, job)">Load Data</button>
	    </div>
      <div>
	    	<button mat-raised-button color="green" style="background: white; color: #75bd4e;" (click)="blankForm(fid)">Clear Current Form</button>
      </div>
	</div>

  <button style="background: white;border: solid; color:black" [mat-dialog-close]="1">Close</button>


  </div>
